import { EnumEnrollmentActiveStatus } from '@v2/domains/person/types/enrollment.types'

import { EnrollmentStatusPerson } from '../enrollmentConfig'
import { Enrollment } from '../types'

const ACTIVE_STATUS = [
  EnumEnrollmentActiveStatus.ACTIVE,
  EnumEnrollmentActiveStatus.LICENSE_GRACE_PERIOD_REACTIVATED,
  EnumEnrollmentActiveStatus.DRIVING_HOURS_REACTIVATED,
  EnumEnrollmentActiveStatus.LICENSE_GRACE_PERIOD,
  EnumEnrollmentActiveStatus.DRIVING_HOURS_APPEAL_PERIOD,
]

export const verifyPersonEnrollmentStatus = (
  enrollment: Enrollment,
): EnrollmentStatusPerson => {
  return ACTIVE_STATUS.includes(enrollment.status as EnumEnrollmentActiveStatus)
    ? EnrollmentStatusPerson.ENROLLED
    : EnrollmentStatusPerson.NOT_ENROLLED
}
